// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"HomeMessages_wrapperComponent__1pzqI","content":"HomeMessages_content__K60Z4","item":"HomeMessages_item__v6HyL"};